import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  checkEligibilityForCardlessEMIAction,
  clearCheckEligibilityForCardlessEMIAction,
  resendOTPForCardlessEMIAction,
  clearResendOTPData,
  checkPanCardEligibilityForCardlessEMIAction,
  validateOTPForCardlessEMIAction,
  CheckSession,
  SESSION_EXPIRES,
  OrderConfirmationWithPanCard,
  SET_CHECKOUT_IS_CANCEL_BUTTON_DISABLED
} from '../../../stores/actions/CommonAction';

import './style.css';
import NotEligiblePopup from './NotEligiblePopup';
import CheckEligibility from './CheckEligibility';
import ProcessScreen from './ProcessScreen';
import { PAYMENT_MODE_CARDLESS_EMI } from '../../../Constants/PaymentModeConstants';

const CardlessEMI = (props) => {
  const [countryCode] = useState('091');
  const [mobileNumber, setMobileNumber] = useState('');
  const [mobileNumberErrorMsg, setMobileNumberErrorMsg] = useState('');
  const [showNotEligiblePopup, setShowNotEligiblePopup] = useState(false);
  const [currentStep, setCurrentStep] = useState('CHECK_ELIGIBILITY');
  const [selectedBank, setSelectedBank] = useState({});
  const [selectedTenure, setselectedTenure] = useState({});
  const [isProceedDisable,updateIsProceedDisable]=useState(false)

  const { cardlessEMIData, merchant_payment_data } = props;

  useEffect(() => {
    setSelectedBank({});
    setselectedTenure({});
  }, [currentStep]);

  useEffect(() => {
    if(merchant_payment_data?.customer_data?.mobile_no)
      setMobileNumber(merchant_payment_data?.customer_data?.mobile_no.toString());
  },[merchant_payment_data])

  useEffect(() => {
    if (cardlessEMIData && Object.keys(cardlessEMIData)?.length > 0) {
      if (
        cardlessEMIData?.issuers?.filter((issuer) => issuer?.eligible === true)
          ?.length > 0
      ) {
        setMobileNumberErrorMsg('');
        setCurrentStep('PROCESS_PAYMENT');
      } else {
        setShowNotEligiblePopup(true);
      }
    } else {
      setCurrentStep('CHECK_ELIGIBILITY');
    }
  }, [cardlessEMIData]);

  useEffect(() => {
    return () => {
      props.clearCheckEligibilityForCardlessEMIAction();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = (e) => {
    // validate mobile number, if true then call API
    e.preventDefault();
    if (mobileNumber?.length >= 10) {
      setMobileNumberErrorMsg('');
      props.checkEligibilityForCardlessEMIAction(props?.token,{
        customer: {
          phone: {
            national_number: mobileNumber,
          },
        },
      });
    } else {
      setMobileNumberErrorMsg('Please enter a valid mobile number');
    }
  };

  const onProceed = (e) => {
    e.preventDefault();
    updateIsProceedDisable(true);
    props
      .CheckSession(props?.token)
      .then((json) => {
        if (json?.data?.response_code === 1) {
          props.SET_CHECKOUT_IS_CANCEL_BUTTON_DISABLED(true);
          document.getElementById('cardless-form').submit();
        } else {
          props.SESSION_EXPIRES();
        }
      })
      .catch((error) => {
        alert('onHandleSubmit:' + error);
      })
  };

  return (
    <div className='cardlessEMI-section'>
      {currentStep === 'PROCESS_PAYMENT' ? (
        <ProcessScreen
          token={props.token}
          mobileNumber={mobileNumber}
          clearCheckEligibilityForCardlessEMIAction={
            props.clearCheckEligibilityForCardlessEMIAction
          }
          checkPanCardEligibilityForCardlessEMIAction={
            props.checkPanCardEligibilityForCardlessEMIAction
          }
          validateOTPForCardlessEMIAction={
            props.validateOTPForCardlessEMIAction
          }
          paymentModeData={props?.merchant_payment_data?.payment_mode_data}
          merchantPaymentData={props?.merchant_payment_data}
          sessionExpires={props.SESSION_EXPIRES}
          cardlessEMIData={cardlessEMIData}
          selectedBank={selectedBank}
          setSelectedBank={setSelectedBank}
          selectedTenure={selectedTenure}
          setselectedTenure={setselectedTenure}
          onProceed={onProceed}
          checkSession={props.CheckSession}
          orderConfirmationWithPanCard={props.OrderConfirmationWithPanCard}
          isProceedDisable={isProceedDisable}
          SET_CHECKOUT_IS_CANCEL_BUTTON_DISABLED={props.SET_CHECKOUT_IS_CANCEL_BUTTON_DISABLED}
          resendOTPData={props.resendOTPData}
          resendOTPForCardlessEMIAction={props.resendOTPForCardlessEMIAction}
          clearResendOTPData={props.clearResendOTPData}
          paymentAmountUI={props.paymentAmountUI}
        />
      ) : (
        <CheckEligibility
          mobileNumber={mobileNumber}
          mobileNumberErrorMsg={mobileNumberErrorMsg}
          setMobileNumber={setMobileNumber}
          onSubmit={onSubmit}
        />
      )}

      {showNotEligiblePopup ? (
        <NotEligiblePopup
          mobileNumber={mobileNumber}
          onCloseClick={() => setShowNotEligiblePopup(false)}
        />
      ) : (
        ''
      )}

      <form
        id='cardless-form'
        method='post'
        action={`${
          process.env.REACT_APP_PG_CONTROLLER
        }pinepg/v2/submit/cardless?token=${encodeURIComponent(props?.token)}`}
        onSubmit={onProceed}
      >
        <input
          type='hidden'
          name='paymentModeId'
          value={PAYMENT_MODE_CARDLESS_EMI}
        />
        <input
          type='hidden'
          name='issuer_name'
          value={selectedBank?.name ? selectedBank?.name : ''}
        />
        <input
          type='hidden'
          name='tenure'
          value={selectedBank?.name === 'AXIO' ? 0 : selectedTenure?.tenure}
        />
        <input type='hidden' name='country_code' value={countryCode} />
        <input type='hidden' name='mobile_number' value={mobileNumber} />
      </form>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    merchant_payment_data:
      state.merchantPaymentDataFetchingReducer.merchantPaymentData,
    token: state.merchantPaymentDataFetchingReducer.token,
    cardlessEMIData:
      state.merchantPaymentDataFetchingReducer.cardlessEMIData || {},
    resendOtpData: state.merchantPaymentDataFetchingReducer.resendOTPData || {},
    paymentAmountUI: state.merchantPaymentDataFetchingReducer.paymentAmountUI
  };
};

export default connect(mapStateToProps, {
  checkEligibilityForCardlessEMIAction,
  clearCheckEligibilityForCardlessEMIAction,
  resendOTPForCardlessEMIAction,
  clearResendOTPData,
  checkPanCardEligibilityForCardlessEMIAction,
  validateOTPForCardlessEMIAction,
  CheckSession,
  SESSION_EXPIRES,
  OrderConfirmationWithPanCard,
  SET_CHECKOUT_IS_CANCEL_BUTTON_DISABLED,
})(CardlessEMI);
